
(function() {
  // Add custom code below this line



  // Find all links
let block = document.querySelector('#cover-block');
let transitionCopy = document.querySelector('.transition-copy');


// On DOM ready, start the "in" animation (faster than window.load on mobile)
function startTransition() {
  if (!transitionCopy && !block) return;

  if (transitionCopy) {
    transitionCopy.classList.add('show');
    setTimeout(() => transitionCopy.classList.remove('show'), 970);
  }

  setTimeout(() => {
    if (block) {
      block.classList.add('show-in');
      block.classList.remove('show-out');
    }
    if (typeof tl !== 'undefined' && tl && typeof tl.play === 'function') {
      tl.play();
    }
  }, 970);
}

// If DOM is still loading wait for DOMContentLoaded, otherwise run now
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startTransition);
} else {
  startTransition();
}


///GSAP and ScrollTrigger animations
  
  gsap.registerPlugin(ScrollTrigger,DrawSVGPlugin);

  const cascadeItems = document.querySelectorAll('[data-cascade-item]');

  // Set initial state for all cascade items: alternate left/right
  cascadeItems.forEach((item, i) => {
    const fromX = i % 2 === 0 ? -80 : 80; // Even: left, Odd: right
    gsap.set(item, { autoAlpha: 0, x: fromX });
    ScrollTrigger.create({
      trigger: item,
      start: "top 60%",
      onEnter: () => {
        gsap.to(item, {
          autoAlpha: 1,
          x: 0,
          duration: 0.8,
          ease: "cubic-bezier(0.4, 0, 0.2, 1)"
        });
      },
      markers: false,
    });
  });

  // for p copy class revel, add a scroll trigger to reveal text using SplitText attach % progress of revelation to the scroll tracker so if user scrolls up it revesres the reveal word by word, fade int stagger
  const revealText = document.querySelectorAll('.reveal-text p');
  revealText.forEach((text) => {
    // const split = new SplitText(text, { type: "words, chars" });
    gsap.set(text, { autoAlpha: 0, y: 0 });

    // Create the reveal animation as a paused timeline
    const tl = gsap.timeline({ paused: true })
      .to(text, {
        autoAlpha: 1,
        y: 0,
        duration: 0.5,
        ease: "power2.out"
      });
      // Run the animation once when the text comes into view
      ScrollTrigger.create({
        trigger: text,
        start: "top 80%",
        onEnter: () => tl.play(),
        once: true,
        markers: false,
      });
  });

     // Select all children of #paths
    const softandgentle = document.querySelectorAll('#paths .soft-and-gentle > .st0');
    const brightandbold = document.querySelectorAll('#paths .bright-and-bold > .st0');
    const electricboogaloo = document.querySelectorAll('#paths .electric-boogaloo');
    const electricboogalooST0 = document.querySelectorAll('#paths .electric-boogaloo > .st0');

    // Combine all paths
    const paths = [...brightandbold, ...softandgentle];
    const electricPaths = [...electricboogalooST0];

    paths.forEach((path) => {
      path.style.vectorEffect = 'none';
    });


    
    // Set initial state for all paths: invisible (drawSVG: "0%")
    gsap.set([...brightandbold, ...softandgentle], { drawSVG: "0%", autoAlpha: 0 });
    gsap.set(electricboogaloo, { autoAlpha: 0 });
    
    // Create the timeline but don't play it yet
    const tl = gsap.timeline({ paused: true });

      // Animate brightandbold paths with stagger
      tl.to(brightandbold, {
        drawSVG: "100%",
        autoAlpha: 1,
        duration: 0.4,
        stagger: 0.08, // Stagger each path by 0.08 seconds
        ease: "power2.Out",
        onComplete: function () {
          console.log('Bright and Bold animation complete for:', this.targets());
          this.targets().forEach((path) => {
            path.style.vectorEffect = 'non-scaling-stroke'; // Reapply non-scaling-stroke after animation completes
          });
        }
      });

      // Animate softandgentle paths with stagger
      tl.to(softandgentle, {
        drawSVG: "100%",
        autoAlpha: 1,
        duration: 0.4,
        stagger: 0.08, // Stagger each path by 0.08 seconds
        ease: "power2.Out"
      });
 
    // Fade in electricboogaloo paths after both groups finish
    tl.to(electricboogaloo, {
      autoAlpha: 1,
      duration: 3,
      ease: "power2.Out",
      delay: 0.5,
      onComplete: function () {
        console.log('Electric Boogaloo animation complete for:', this.targets());
        this.targets().forEach((path) => {
          softandgentle.forEach((softPath) => {
            softPath.style.vectorEffect = 'non-scaling-stroke'; // Reapply non-scaling-stroke after animation completes
          });
          path.style.vectorEffect = 'non-scaling-stroke'; // Reapply non-scaling-stroke after animation completes
        });
      }
    });


  // Set initial state for all paths: invisible (drawSVG: "0%")
  // gsap.registerPlugin(DrawSVGPlugin);
  // const paths = document.querySelectorAll('#paths > *');
  // gsap.set(paths, { drawSVG: "0%" });
  // Animate all paths to draw from 0% to 100% with stagger
  // gsap.to(paths, {
  //   drawSVG: "100%",
  //   duration: 0.25,
  //   stagger: 0.10,
  //   ease: "power1.inOut"
  // });
  

  // // Set all to invisible (drawSVG: "0%")
  // gsap.set(paths, { drawSVG: "0%" });

  // // Animate each path in sequence
  // gsap.to(paths, {
  //   drawSVG: "100%",
  //   duration: 0.25,
  //   stagger: 0.10,
  //   ease: "power1.inOut"
  // });


  /// scroll trigerr on reveal of section with ul.splide__list stagger reveal each li child with a delay of 0.1s and fade in
  const splideLists = document.querySelectorAll('ul.splide__list');
  splideLists.forEach((list) => {
    const items = list.querySelectorAll('li');
    // Set initial state for all items: invisible
    gsap.set(items, { autoAlpha: 0, y: 0 });

    // Create the reveal animation as a paused timeline
    const listtl = gsap.timeline({ paused: true })
      .to(items, {
        autoAlpha: 1,
        y: 0,
        duration: 1,
        ease: "power2.out",
        stagger: 0.2
      });

    // Run the animation once when the list comes into view
    ScrollTrigger.create({
      trigger: list,
      start: "top 80%",
      onEnter: () => listtl.play(),
      once: true,
      markers: false,
    });
  }
  );

  // for all immediate child elements of ".pt-section .lg\\:grid" fade in sequencially staggered
  // For each .pt-section, create its own trigger and timeline for staggered reveal of immediate children of .lg\:grid
  document.querySelectorAll('.pt-section .lg\\:grid').forEach((ptSectionGrid) => {
    const children = ptSectionGrid.children;
    gsap.set(children, { autoAlpha: 0, y: 0 });

    const sectiontl = gsap.timeline({ paused: true })
      .to(children, {
        autoAlpha: 1,
        y: 0,
        duration: 0.7,
        ease: "power2.out",
        stagger: 0.15
      });

    ScrollTrigger.create({
      trigger: ptSectionGrid,
      start: "top 80%",
      onEnter: () => sectiontl.play(),
      once: true,
      markers: false // <-- debug indicators enabled
    });
  });

  
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();